import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../../Context/AuthContext";
import { FilePond, registerPlugin } from "react-filepond";
import { AspectRatio } from "react-aspect-ratio";
import "filepond/dist/filepond.min.css";
import { useAlert } from "react-alert";
import { constant } from "../../../Constants/constant";
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
import { PageBody } from "../../../components/loader";
import { useLoadingMessage } from "../../../components/useLoadingMessage";
import axios from "axios";

registerPlugin(FilePondPluginFileValidateType);

export const OfficeStructureIndex = () => {
  const { user } = useContext(AuthContext);
  const alert = useAlert();
  const [background, setBackground] = useState(``);
  const [image, setImage] = React.useState({});
  const { isLoading, message, updateLoader } = useLoadingMessage();

  const update = () => {
    updateLoader(true, "Changing Backround");
    setBackground(`${constant.OfficeURL}/needle-structure.jpg`);
    updateLoader(false);
  };

  const upload = (e) => {
    e.preventDefault();
    let formData = new FormData();
    formData.append("file", image);

    const token = localStorage.getItem("token");

    const headers = {
      "Content-Type": "multipart/form-data",
    };

    if (token) {
      headers["Authorization"] = `Bearer ${token}`;
    }

    axios({
      method: "post",
      url: `${constant.PostOfficeImg}/upload`,
      data: formData,
      headers: headers,
    })
      .then(function (response) {
        update();
        alert.success(response.data.msg);
      })
      .catch(function (response) {
        //handle error
        console.log(response);
      });
    update();
  };

  const handleUpload = (e) => {
    let file = e.target.files[0];
    setImage(file);
  };

  useEffect(() => {
    update();
  }, [background]);
  return (
    <React.Fragment>
      <PageBody isLoading={isLoading} message={message}>
        <div className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-12">
                <div className="page-title-box-two">
                  <h4 className="page-title"></h4>
                  <h1 className="welcome_text">OFFICE STRUCTURE</h1>
                  <div className="clearfix"></div>
                </div>
              </div>
            </div>

            <nav
              className="navbar navbar-light navbar-expand-md bg-faded justify-content-center"
              style={{ backgroundColor: "#243050" }}
            >
              <a href="/" className="navbar-brand d-flex w-50 mr-auto"></a>
            </nav>

            {(user.data.user.roles && user.data.user.roles.name === "admin") ||
            user.data.user.roles.name === "human resource" ? (
              <div className="row">
                <div className="col-md-12">
                  {/* <FilePond
                  name="file"
                  files={file}
                  allowMultiple={false}
                  server={{
                    allowFileTypeValidation: true,
                    acceptedFileTypes: ["image/png", "image/jpeg"],
                    labelFileTypeNotAllowed: "File type not allowed",
                    url: `${constant.PostOfficeImg}/upload`,
                    process: {
                      headers: {
                        Authorization: `Bearer ${localStorage.getItem(
                          "token"
                        )}`,
                      },
                      onload: (res) => {
                        if (res) {
                          alert.success("uploaded successfully");
                          setBackground(
                            `${constant.OfficeURL}/office-structure/needle-structure.jpg`
                          );
                          update();
                        }
                      },
                      onerror: (e) => {
                        alert.error("an error occur while uploading");
                      },
                    },
                  }}
                  oninit={() => this.handleInit()}
                  onupdatefiles={(fileItems) => {
                    setFile({
                      files: fileItems.map((fileItem) => fileItem.file),
                    });
                  }}
                ></FilePond> */}
                  <form onSubmit={upload} className="text-center">
                    <input
                      type="file"
                      onChange={handleUpload}
                      // ref={image}
                    />
                    <div className="text-center">
                      <button
                        variant="success"
                        type="submit"
                        size="lg"
                        className="btn"
                      >
                        Submit
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            ) : null}

            <div className="row vv">
              <div className="col-md-12">
                <AspectRatio ratio="3/4">
                  <img
                    src={background}
                    class="img-fluid"
                    alt="Needle Office Structure"
                  />
                </AspectRatio>
              </div>
            </div>
          </div>
        </div>
      </PageBody>
    </React.Fragment>
  );
};



// WEBPACK FOOTER //
// ./src/container/dashboard/officestructure/index.js